/**
 * Dashboard Header Component
 * Displays welcome message and current date
 */
import { formatDate } from '@/utils/format';

interface DashboardHeaderProps {
  userName: string | null;
}

export default function DashboardHeader({ userName }: DashboardHeaderProps) {
  const today = new Date();
  const greeting = getGreeting();

  return (
    <div className="mb-8">
      <h1 className="text-2xl font-bold text-gray-900">
        {greeting}
        {userName ? `, ${userName}` : ''}
      </h1>
      <p className="mt-1 text-gray-600">
        {formatDate(today, {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })}
      </p>
    </div>
  );
}

/**
 * Get time-appropriate greeting
 */
function getGreeting(): string {
  const hour = new Date().getHours();

  if (hour < 12) {
    return 'Good morning';
  } else if (hour < 17) {
    return 'Good afternoon';
  } else {
    return 'Good evening';
  }
}
